import PropTypes from 'prop-types';
import { Box, Stack, Typography } from '@mui/material';

const styles = {
  tooltip: ({ palette }) => ({
    width: 280,
    backgroundColor: palette.text.primary,
    borderRadius: 4,
    overflow: 'hidden',
  }),
  line: ({ palette, spacing }) => ({
    padding: spacing(1, 2.5),
    borderBottom: `1px solid ${palette.colors.darkGrey}`,
    '&:last-child': {
      borderBottom: 'none',
    },
  }),
  name: { minWidth: 0 },
  value: {
    minWidth: 30,
    flexShrink: 0,
    textAlign: 'right',
  },
};

export const MultiSeriesTooltip = ({ active = false, payload = [] }) => {
  if (!active || !payload) {
    return null;
  }

  return (
    <Box sx={styles.tooltip}>
      {payload.map((item) => (
        <Stack
          key={item.name}
          direction="row"
          spacing={1}
          justifyContent="space-between"
          alignItems="center"
          sx={styles.line}
        >
          <Typography noWrap color={item.stroke} sx={styles.name}>
            {item.name}
          </Typography>
          <Typography color={item.stroke} sx={styles.value}>
            {item.value}
          </Typography>
        </Stack>
      ))}
    </Box>
  );
};

MultiSeriesTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.number,
      stroke: PropTypes.string,
    }),
    PropTypes.bool,
  ),
};
